import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

export const data = {
  path: '/calc/',
  layoutType: 'inset'
}

class CalcIndex extends React.Component {
  render() {
    const calcs = this.props.data.allMarkdownRemark.edges
    let calcBlocks = calcs.map(calc => {
      return (
        <div className="box" key={calc.node.fields.slug}>
          <h1 className="title">
            <Link to={`/calc${calc.node.fields.slug}`}>
              {calc.node.frontmatter.title}
            </Link>
          </h1>
          <h2 className="subtitle">
            {calc.node.frontmatter.author}
          </h2>
          <p>{calc.node.excerpt}</p>
        </div>
      )
    })

    return (
      <div>
        {calcBlocks}
      </div>
    )
  }
}

export default CalcIndex

export const pageQuery = graphql`
  query calcOverview {
    allMarkdownRemark(filter: {frontmatter: {path: {ne: "/404.html"}}}) {
      edges {
        node {
          excerpt
          frontmatter {
            title
            author
          }
          fields {
            slug
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/calculators/index.js